var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "176px",
    height: "124px",
    viewBox: "0 0 176 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yt_icon_rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.04 176 0.04 176 124 0.06 124"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yt_icon_rgb",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.322,19.363 C170.298,11.741 164.335,5.739 156.762,3.702 C143.037,0 88,0 88,0 C88,0 32.963,0 19.238,3.702 C11.666,5.739 5.702,11.741 3.678,19.363 C0,33.177 0,62 0,62 C0,62 0,90.822 3.678,104.638 C5.702,112.259 11.666,118.261 19.238,120.299 C32.963,124 88,124 88,124 C88,124 143.037,124 156.762,120.299 C164.335,118.261 170.298,112.259 172.322,104.638 C176,90.822 176,62 176,62 C176,62 176,33.177 172.322,19.363",
    id: "Fill-1",
    fill: "#D9252A",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#FFFFFE",
    points: "70 88.169 116 62.001 70 35.831 70 88.169"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt_icon.e1a563b287a88b672b6cb4a50e8333a6.svg";
export { ForwardRef as ReactComponent };